import { useEffect, useState } from 'react';
import Image from 'next/legacy/image';
import { JoinedFormFieldProps } from 'types';

import cx from 'classnames';
import styles from './RadioBox.module.scss';

export const ReachRadioBlock = ({ fieldName = '', reachOptions = [], value, onChange, isDisabled }: JoinedFormFieldProps) => {
  const [activeItem, setActiveItem] = useState(value || reachOptions?.[0].option);

  useEffect(() => {
    onChange && onChange(fieldName, activeItem);
  }, [activeItem]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className={styles.reachRadioBlockWrapper}>
      {reachOptions.map((option, id) => {
        const isActive = activeItem === option.option;
        return (
          <div
            key={id}
            className={cx(styles.reachRadioItem, { [styles.active]: isActive })}
            onClick={() => !isDisabled && setActiveItem(option.option)}
          >
            <div className={styles.rightPart}>
              <Image src={option.icon} width={32} height="32" alt={option.caption} />
              <p className={cx(styles.reachCaption, {[styles.activeOption]: isActive})}>{option.caption}</p>
            </div>
            <div className={styles.leftPart}>
              {isActive && <Image src="/icons/checkbox/TickRounded.svg" width={24} height={24} alt={fieldName} />}
            </div>
          </div>
        );
      })}
    </div>
  );
};
